import {
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useColorMode,
  useDisclosure,
} from "@chakra-ui/react";

export default function SubstackModal2() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { colorMode } = useColorMode();

  const buttonText = colorMode === "light" ? "text-black" : "text-white";
  const backgroundColor = colorMode === "light" ? "white" : "white";

  const buttonBG = colorMode === "light" ? "white" : "black";

  return (
    <>
      <Center>
        <Center mt={5}>
          <Button
            onClick={onOpen}
            variant="outline"
            padding="22px"
            margin={8}
            borderRadius={15}
            borderStyle="solid"
            borderColor={"rgba(255,102,196,0.9)"}
            borderWidth={1}
            colorScheme="black"
          >
            <Text>Join The Collector{`'`}s Club</Text>
          </Button>

          {/* rgba(255,153,213,0.9), rgba(255,102,196,0.9) */}
        </Center>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent backgroundColor={backgroundColor}>
            <ModalCloseButton
              style={{ color: "black", marginRight: 20, marginTop: 5 }}
            />
            <ModalBody>
              <Center>
                <iframe
                  src="https://songcards.substack.com/embed"
                  width="100%"
                  height={320}
                  style={{ border: "1px solid #EEE", background: "white" }}
                ></iframe>
              </Center>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Center>
    </>
  );
}
